import React, { useState } from "react";
import Header from "../components/Header";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import "./ContactPage.css";

export default function ContactPage() {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "kz");

  const t = {
    kz: {
      subtitle: "Сұрақтарыңыз болса, бізбен байланысыңыз",
      email: "support@expertise.kz",
      phone: "+7 (7172) 99-99-99",
      address: "Астана қ., Достық көшесі, 13",
    },
    ru: {
      subtitle: "Если у вас есть вопросы — свяжитесь с нами",
      email: "support@expertise.kz",
      phone: "+7 (7172) 99-99-99",
      address: "г. Астана, ул. Достык, 13",
    },
  }[locale];

  const telHref = t.phone.replace(/[^\d+]/g, ""); // для tel:

  return (
    <div className="contact-page">
      {/* правый анимированный орнамент */}
      <div className="contact-ornament glow sparkles" aria-hidden="true">
        <div className="orn-img a" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
        <div className="orn-img b" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
        <div className="orn-img c" style={{ backgroundImage: "url(/img/ornament.svg)" }} />
      </div>

      {/* делаем как на HomePage */}
      <div className="container header-wrap">
        <Header locale={locale} setLocale={setLocale} />
      </div>

      <main className="container contact-wrapper">
        <section className="contact-card glass">
          <h2 className="section-title">{t.subtitle}</h2>

          <ul className="contact-list">
  <li className="contact-item">
    <span className="icon-wrap"><FiMail /></span>
    <div className="contact-info">
      <span className="contact-label">Email</span>
      <a href={`mailto:${t.email}`}>{t.email}</a>
    </div>
  </li>
  <li className="contact-item">
    <span className="icon-wrap"><FiPhone /></span>
    <div className="contact-info">
      <span className="contact-label">{locale === "kz" ? "Телефон" : "Телефон"}</span>
      <a href={`tel:${telHref}`}>{t.phone}</a>
    </div>
  </li>
  <li className="contact-item">
    <span className="icon-wrap"><FiMapPin /></span>
    <div className="contact-info">
      <span className="contact-label">{locale === "kz" ? "Мекенжай" : "Адрес"}</span>
      <span>{t.address}</span>
    </div>
  </li>
</ul>
          <div className="brand-name">BMSO</div>
        </section>
      </main>
    </div>
  );
}
